export default __webpack_public_path__ + "static/media/md-card-bg-AZ-305.06d00390.png";